import React, { useState, useEffect, useCallback } from "react";
import { Typography, Table, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Pageloader from "../../../components/loader";
import TableCaret from "../../../components/tableCaret/tableCaret";
import { dataKey } from "../../../utils/Helpers";
import PerformanceFilter from "./filter";
import moment from "moment";
import * as performanceActions from "../../../redux/actions/performance.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title } = Typography;
const pageName = "Performance";

const PerformanceListing = (props) => {
  const [postData, setPostData] = useState(null);

  useEffect(() => {
    // if (props.formData.zone && props.formData.zone != null){
        postLists(props.formData)
    // }
  }, [props.formData])

  const postLists = useCallback(async(value) => {
    const [start, end] = (value?.date === null || value?.date === undefined) ? "" : value?.date;
    const pageFilterData = {
      ...value,
      startDate: start === undefined ? moment.unix(moment()) : start.set({hour:0,minute:0,second:0,millisecond:0}).toISOString(),
      endDate: end === undefined ? moment.unix(moment()) : end.endOf('day').toISOString(),
    };
    delete pageFilterData["date"];
    try {
      await props.performanceActions.listPerformanceAction(pageFilterData);
    } catch (e) {}
  }, [props.formData])


  useEffect(() => {
    if (props.pageData){setPostData(dataKey(props.pageData))}
  }, [props.pageData]);
  
  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.formData,
      page: page,
      limit: limit,
    };
    try {
      await props.performanceActions.filterPerformanceAction(pageData);
    } catch {}
  };

  let _ = require('lodash');
  const [sc, setsc] = useState({
    value:  "",
    sort:  'desc',
  })
  const sorting = (value) => {
    if (value && value === sc.value){
      if (sc.sort === 'desc'){
        setPostData(_.orderBy(Object.values(postData), [value], ['asc']));
        setsc({ value:  value, sort:  'asc' })
      }else {
        setPostData(_.orderBy(Object.values(postData), [value], ['desc']));
        setsc({ value:  value, sort:  'desc' })
      }
    } else {
      setPostData(_.orderBy(Object.values(postData), [value], ['desc']));
      setsc({ value:  value, sort:  'desc' })
    }
  }

  const columns = [
    {
      title: ()=><div onClick={()=>sorting("rider.display_id")}>
        Rider ID
        <TableCaret value={"rider.display_id"} sort={sc}/>
      </div>,
      dataIndex: 'rider',
      render: (value) => (value?.display_id||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("rider.fullName")}>Rider Name <TableCaret value={"rider.fullName"} sort={sc}/></div>,
      dataIndex: 'rider',
      render: (value) => (value?.fullName||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("rider.batch.batchLevel")}>
        Batch
        <Tooltip placement="topRight" title="Rider's current batch"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"rider.batch.batchLevel"} sort={sc}/>
      </div>,
      dataIndex: 'rider',
      render: (value) => (value?.batch?.batchLevel||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("total_shifts")}>
        Total Picked Shifts
        <Tooltip placement="topRight" title="Count of shifts picked by rider"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"total_shifts"} sort={sc}/>
      </div>,
      dataIndex: 'total_shifts',
      render: (value) => (value||"-"),
    },    
    {
      title: ()=><div onClick={()=>sorting("rate.late_login")}>
        Late Login
        <Tooltip placement="topRight" title="Number of times rider logged in 15 mints after shift scheduled start time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"rate.late_login"} sort={sc}/>
      </div>,
      dataIndex: 'rate',
      render: (value) => (value?.late_login||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("rate.no_show")}>
        No Show
        <Tooltip placement="topRight" title="Number of times rider did not login the shift"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"rate.no_show"} sort={sc}/>
      </div>,
      dataIndex: 'rate',
      render: (value) => (value?.no_show||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("total_delivered_orders")}>
        Orders Delivered
        <Tooltip placement="topRight" title="Count of orders delivered by rider"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"total_delivered_orders"} sort={sc}/>
      </div>,
      dataIndex: 'total_delivered_orders',
      render: (value) => (value||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("total_hours_worked")}>
        Actual Worked Hours
        <Tooltip placement="topRight" title="Total shifts scheduled time - (minus) total break time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"total_hours_worked"} sort={sc}/>
      </div>,
      dataIndex: 'total_hours_worked',
      render: (value) => {return `${Math.floor(value)}hr ${Math.round(value % 60)}m`}
    },
    {
      title: ()=><div onClick={()=>sorting("total_hours_planned")}>
        Scheduled Hours
        <Tooltip placement="topRight" title="Total time of shifts picked by rider"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"total_hours_planned"} sort={sc}/>
      </div>,
      dataIndex: 'total_hours_planned',
      render: (value) => {return `${Math.floor(value)}hr ${Math.round(value % 60)}m`}
    },
    {
      title: ()=><div onClick={()=>sorting("utr")}>
        UTR
        <Tooltip placement="topRight" title={(<>Orders delivered by rider during his actual worked hours. <b>Calculation:</b> orders delivered / actual worked hours</>)}><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"utr"} sort={sc}/>
      </div>,
      dataIndex: 'utr',
      render: (value) => (value?Number(value).toFixed(2):"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("actual_vs_schedule_hours")}>
        Actual vs Scheduled Hours
        <Tooltip placement="topRight" title={(<>Actual worked hours by rider vs Total time of shifts picked by rider. <b>Calculation:</b> Actual worked hours / scheduled hours</>)}><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"actual_vs_schedule_hours"} sort={sc}/>
      </div>,
      dataIndex: 'actual_vs_schedule_hours',
      render: (value) => (value?Number(value).toFixed(2):"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("overtime_worked")}>
        Overtime Worked (Hours)
        <Tooltip placement="topRight" title="Total number of hours worked in overtime time shifts"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"overtime_worked"} sort={sc}/>
      </div>,
      dataIndex: 'overtime_worked',
      render: (value) => (value?value:"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("special_hours_worked")}>
        Special Hours Worked
        <Tooltip placement="topRight" title="Total number of hours worked in special hours shifts"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"special_hours_worked"} sort={sc}/>
      </div>,
      dataIndex: 'special_hours_worked',
      render: (value) => (value?value:"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("acceptance_rate")}>
        Acceptance Rate
        <Tooltip placement="topRight" title={(<>Percentage of order requests <b>accepted</b> by rider. <b>Calculation:</b> number of order requests accepted / total number of requests. (Same order is being considered only once)</>)}><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"acceptance_rate"} sort={sc}/>
      </div>,
      dataIndex: 'acceptance_rate',
      render: (value) => (value?(Math.round(value * 100) / 100).toFixed(2)+"%":"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("rejection_rate")}>
        Rejection Rate
        <Tooltip placement="topRight" title={(<>Percentage of order requests <b>rejected</b> by rider. <b>Calculation:</b> number of orders declined or timedout / total number of requests. (Same order is being considered only once)</>)}><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"rejection_rate"} sort={sc}/>
      </div>,
      dataIndex: 'rejection_rate',
      render: (value) => (value?(Math.round(value * 100) / 100).toFixed(2)+"%":"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("completion_rate")}>
        Completion Rate
        <Tooltip placement="topRight" title={(<>Percentage of orders delivered by rider. <b>Calculation:</b> number of orders delivered / total number of accepted orders</>)}><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"completion_rate"} sort={sc}/>
      </div>,
      dataIndex: 'completion_rate',
      render: (value) => (value?(Math.round(value * 100) / 100).toFixed(2)+"%":"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("cancellation_rate")}>
        Cancellation Rate
        <Tooltip placement="topRight" title={(<>Percentage of canceled orders. <b>Calculation:</b> number of orders canceled / total number of accepted orders</>)}><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"cancellation_rate"} sort={sc}/>
      </div>,
      dataIndex: 'cancellation_rate',
      render: (value) => (value?(Math.round(value * 100) / 100).toFixed(2)+"%":"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("time_categories_count.under_twenty_count")}>
        Under 20 Minutes
        <Tooltip placement="topRight" title="count of orders delivered within 20 mints of order creation time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"time_categories_count.under_twenty_count"} sort={sc}/>
      </div>,
      dataIndex: 'time_categories_count',
      render: (value) => (value?.under_twenty_count||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("time_categories_count.under_thirty_count")}>
        Under 30 Minutes
        <Tooltip placement="topRight" title="count of orders delivered within 30 mints of order creation time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"time_categories_count.under_thirty_count"} sort={sc}/>
      </div>,
      dataIndex: 'time_categories_count',
      render: (value) => (value?.under_thirty_count||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("time_categories_count.under_sixty_count")}>
        Under 60 Minutes
        <Tooltip placement="topRight" title="count of orders delivered within 60 mints of order creation time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"time_categories_count.under_sixty_count"} sort={sc}/>
      </div>,
      dataIndex: 'time_categories_count',
      render: (value) => (value?.under_sixty_count||"-"),
    },
    {
      title: ()=><div onClick={()=>sorting("time_categories_count.greater_sixty_count")}>
        Greater than 60 Minutes
        <Tooltip placement="topRight" title="count of orders delivered after 60 mints of order creation time"><InfoCircleOutlined /></Tooltip>
        <TableCaret value={"time_categories_count.greater_sixty_count"} sort={sc}/>
      </div>,
      dataIndex: 'time_categories_count',
      render: (value) => (value?.greater_sixty_count||"-"),
    },
  ]


  return (
    <div className="page-content">
      <div className="page-content-header">
          <Title level={2}>{pageName}</Title>
        <div className="pch"></div>
      </div>
      <PerformanceFilter />
      <div className="p-content">
        {props.pageLoader ? <Pageloader/> : 
          <Table
            className="table-ws table-tcenter"
            dataSource={postData}
            columns={columns}
            pagination={{
              total: props?.pagePagination?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: props?.pagePagination?.limit,
              defaultCurrent: props?.pagePagination?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (page, pageSize) => {paginationChange(page, pageSize)},
            }}
          />}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pageData: state.PerformanceReducer.performanceData,
    pagePagination: state.PerformanceReducer.performancePagination,
    formData: state.PerformanceReducer.performanceFilter,
    pageLoader: state.PerformanceReducer.performanceLoader,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    performanceActions: bindActionCreators(performanceActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PerformanceListing);